import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormHelperText } from '@mui/material';
//
import { Upload, UploadImage, UploadVideo } from '../Upload';
import UploadDocument from '../Upload/uploadpdfdocument';

// ----------------------------------------------------------------------

RHFUpload.propTypes = {
    name: PropTypes.string,
    multiple: PropTypes.object,

    helperText: PropTypes.node,
    patchFileName: PropTypes.string,

};

export function RHFUpload({ name, multiple, helperText, patchFileName, ...other }) {
    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>

                <Upload
                    accept=".xlsx"
                    multiple
                    files={field.value}
                    error={!!error}
                    helperText={
                        (!!error || helperText) && (
                            <FormHelperText error={!!error} sx={{ px: 2 }}>
                                {error ? error?.message : helperText}
                            </FormHelperText>
                        )
                    }
                    patchFileName={patchFileName}
                    {...other}
                />

            }
        />
    );
}

RHFUploadImage.propTypes = {
    name: PropTypes.string,
    multiple: PropTypes.bool,
    helperText: PropTypes.node,
};

export function RHFUploadImage({ name, multiple, helperText, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                multiple ? (
                    <UploadImage
                        multiple
                        accept={{ 'image/*': [] }}
                        files={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                ) : (
                    <UploadImage
                        accept={{ 'image/*': [] }}
                        file={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                )
            }
        />
    );
}

RHFUploadDocument.propTypes = {
    name: PropTypes.string,
    multiple: PropTypes.bool,
    helperText: PropTypes.node,
};

export function RHFUploadDocument({ name, multiple, helperText, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                multiple ? (
                    <UploadDocument
                        multiple
                        accept='application/pdf'
                        files={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                ) : (
                    <UploadDocument
                        accept='application/pdf'
                        file={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                )
            }
        />
    );
}

RHFUploadVideo.propTypes = {
    name: PropTypes.string,
    multiple: PropTypes.bool,
    helperText: PropTypes.node,
};

export function RHFUploadVideo({ name, multiple, helperText, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                multiple ? (
                    <UploadVideo
                        multiple
                        accept={{ 'video/*': [] }}
                        files={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                ) : (
                    <UploadVideo
                        accept={{ 'video/*': [] }}
                        file={field.value}
                        error={!!error}
                        helperText={
                            (!!error || helperText) && (
                                <FormHelperText error={!!error} sx={{ px: 2 }}>
                                    {error ? error?.message : helperText}
                                </FormHelperText>
                            )
                        }
                        {...other}
                    />
                )
            }
        />
    );
}